import React from 'react'
import {
  AnalysisMetricCardProps,
  MetricHeaderProps,
  MetricIconProps,
  MetricTitleProps,
  MetricValueProps,
  MetricSubtextProps,
  MetricsGridProps,
} from './AnalysisMetricCard.types'
import {
  MetricsGrid as StyledMetricsGrid,
  MetricCard as StyledMetricCard,
  MetricHeader as StyledMetricHeader,
  MetricIcon as StyledMetricIcon,
  MetricTitle as StyledMetricTitle,
  MetricValue as StyledMetricValue,
  MetricSubtext as StyledMetricSubtext,
} from './AnalysisMetricCard.styles'

export const AnalysisMetricsGrid: React.FC<MetricsGridProps> = ({
  children,
  className,
  style,
}) => {
  return (
    <StyledMetricsGrid className={className} style={style}>
      {children}
    </StyledMetricsGrid>
  )
}

export const AnalysisMetricCard: React.FC<AnalysisMetricCardProps> = ({
  children,
  className,
  style,
}) => {
  return (
    <StyledMetricCard className={className} style={style}>
      {children}
    </StyledMetricCard>
  )
}

export const MetricHeader: React.FC<MetricHeaderProps> = ({
  children,
  className,
  style,
}) => {
  return (
    <StyledMetricHeader className={className} style={style}>
      {children}
    </StyledMetricHeader>
  )
}

export const MetricIcon: React.FC<MetricIconProps> = ({
  color,
  children,
  className,
  style,
}) => {
  return (
    <StyledMetricIcon $color={color} className={className} style={style}>
      {children}
    </StyledMetricIcon>
  )
}

export const MetricTitle: React.FC<MetricTitleProps> = ({
  children,
  className,
  style,
}) => {
  return (
    <StyledMetricTitle className={className} style={style}>
      {children}
    </StyledMetricTitle>
  )
}

export const MetricValue: React.FC<MetricValueProps> = ({
  children,
  className,
  style,
}) => {
  return (
    <StyledMetricValue className={className} style={style}>
      {children}
    </StyledMetricValue>
  )
}

export const MetricSubtext: React.FC<MetricSubtextProps> = ({
  children,
  className,
  style,
}) => {
  return (
    <StyledMetricSubtext className={className} style={style}>
      {children}
    </StyledMetricSubtext>
  )
}

AnalysisMetricsGrid.displayName = 'AnalysisMetricsGrid'
AnalysisMetricCard.displayName = 'AnalysisMetricCard'
MetricHeader.displayName = 'MetricHeader'
MetricIcon.displayName = 'MetricIcon'
MetricTitle.displayName = 'MetricTitle'
MetricValue.displayName = 'MetricValue'
MetricSubtext.displayName = 'MetricSubtext'
